export * from './confirm-registration.interface';
